<div style="display:flex; align-items:center; justify-content:center; min-height:100vh; background:#f5f5f5;">
  <div style="text-align:center; padding:40px; background:#fff; border-radius:8px; max-width:480px; box-shadow:0 2px 12px rgba(0,0,0,0.1);">

    <ng-container *ngIf="!isError">
      <div style="font-size:64px; margin-bottom:16px;">&#10003;</div>
      <h2 style="color:#2d7d46; margin-bottom:12px;">Solicitud confirmada</h2>
      <p style="color:#555;">Su solicitud ha sido aprobada correctamente.</p>
    </ng-container>

    <ng-container *ngIf="isError">
      <div style="font-size:64px; margin-bottom:16px;">&#10007;</div>
      <h2 style="color:#c0392b; margin-bottom:12px;">Enlace no válido</h2>
      <p style="color:#555;">El enlace de confirmación no es válido o ya ha sido utilizado. Si necesita ayuda, póngase en contacto con nosotros en <a href="mailto:ayuda@myposventa.es">ayuda@myposventa.es</a>.</p>
    </ng-container>

  </div>
</div>
